<div id="container1" class="container"></div>
<div
  #serieProposalModal
  class="serie-proposal-modal"
  *ngIf="serieProposal$ | async as serieProposal"
>
  <!-- Page Header -->
  <div class="modal-header sale-modal">
    <div class="d-flex justify-content-between w-100 pe-3 align-items-start">
      <h2 class="modal-title">
        {{ 'serieProposalModule.serieProposal' | translate }}:
        {{ (productEntities$ | async)[serieProposal.productId]?.description }}
        -
        {{
          (memberEntities$ | async)[serieProposal?.customerPersonId]?.firstName
        }}
        {{
          (memberEntities$ | async)[serieProposal?.customerPersonId]?.lastName
        }}
      </h2>

      <div class="ms-3">
        <button
          type="button"
          *ngIf="serieProposal.status == serieProposalStatus.COUNTER_PROPOSAL"
          class="btn btn-ghost-primary"
          (click)="onClickShowInitialRequest(serieProposal)"
        >
          {{ 'serieProposalModule.showInitialRequest' | translate }}
        </button>

        <button class="btn btn-sm btn-white" type="button">
          <span
            class="badge fs-6"
            [ngClass]="{
              'bg-soft-primary':
                serieProposal?.status == serieProposalStatus.REQUESTED,
              'bg-soft-warning':
                serieProposal?.status == serieProposalStatus.COUNTER_PROPOSAL,
              'bg-soft-success':
                serieProposal?.status == serieProposalStatus.ACCEPTED,
              'bg-soft-danger':
                serieProposal?.status == serieProposalStatus.DECLINED
            }"
          >
            {{
              'serieProposalModule.serieProposalStatus' + serieProposal?.status
                | translate
            }}</span
          >
        </button>
      </div>
    </div>

    <button
      data-test-id="booking-show-modal-close-button"
      type="button"
      class="btn-close"
      attr.aria-label="{{ 'general.close' | translate }}"
      (click)="cancel()"
    ></button>
  </div>
  <!-- End Page Header -->

  <div class="modal-body booking-modal-content-wrapper py-0">
    <nav attr.aria-label="{{ 'wcag.serieProposalMenu' | translate }}">
      <ul
        class="nav nav-tabs align-items-center mb-3"
        *ngIf="serieProposal"
        role="tablist"
      >
        <li class="nav-item">
          <a
            href="javascript:;"
            class="nav-link"
            (click)="activeTab = 'general'"
            [ngClass]="{
              active: activeTab == 'general'
            }"
            role="tab"
            [attr.aria-selected]="activeTab == 'general' ? 'true' : 'false'"
            aria-controls="panel-general"
          >
            <i role="img" class="fa me-1 fa-cube" aria-hidden="true"></i>
            {{ 'general.general' | translate }}
          </a>
        </li>

        <!-- <li class="nav-item">
        <a
          href="javascript:;"
          class="nav-link"
          (click)="activeTab = 'details'"
          [ngClass]="{
            active: activeTab == 'details'
          }"
        >
          <i role="img" class="fa me-1 fa-pen" aria-hidden="true"></i>

          {{ 'general.details' | translate }}
        </a>
      </li> -->

        <li class="nav-item">
          <a
            href="javascript:;"
            class="nav-link"
            (click)="activeTab = 'serie'"
            [ngClass]="{
              active: activeTab == 'serie'
            }"
            role="tab"
            [attr.aria-selected]="activeTab == 'serie' ? ' true' : 'false'"
            aria-controls="panel-serie"
          >
            <i role="img" class="fa me-1 fa-stream" aria-hidden="true"></i>
            {{ 'serieProposalModule.serie' | translate }}
          </a>
        </li>
        <li class="nav-item position-relative">
          <a
            href="javascript:;"
            class="nav-link"
            (click)="activeTab = 'messages'"
            [ngClass]="{
              active: activeTab == 'messages'
            }"
            role="tab"
            [attr.aria-selected]="activeTab == 'messages' ? 'true' : 'false'"
            aria-controls="panel-messages"
          >
            <i role="img" class="fa fa-comment me-1" aria-hidden="true"></i>
            {{ 'general.messages' | translate }}
          </a>

          <span
            *ngIf="messageService.hasNewMessage(serieProposal)"
            class="badge bg-primary position-absolute"
            style="top: 0px; right: -10px"
          >
            {{ 'general.new' | translate }}
          </span>
        </li>
      </ul>
    </nav>
  </div>
  <!-- End Nav -->

  <div class="modal-body pt-0">
    <serie-proposal-general-tab
      *ngIf="activeTab == 'general'"
      [serieProposalId]="serieProposal.id"
      [isModal]="true"
      (onCloseModal)="cancel()"
      id="panel-general"
    ></serie-proposal-general-tab>

    <serie-proposal-series-tab
      *ngIf="activeTab == 'serie'"
      [serieProposalId]="serieProposal.id"
      id="panel-serie"
    ></serie-proposal-series-tab>

    <serie-proposal-messages-tab
      *ngIf="activeTab == 'messages'"
      [serieProposalId]="serieProposal.id"
      id="panel-messages"
    ></serie-proposal-messages-tab>
  </div>
</div>
